// extracted by mini-css-extract-plugin
export default {"panel":"panel--qehNy","collapse":"collapse--p6QPq","collapseRoot":"collapseRoot--B9wo8","collapseWrapperInner":"collapseWrapperInner--K0LNG","card":"card--vKGGk"};